<mat-icon [svgIcon]="icon" *ngIf="icon"></mat-icon>
<span class="message"> {{message | translate:messageParams}}</span>
<button mat-flat-button *ngIf="action" (click)="onAction()">{{action | translate}}</button>
<button mat-icon-button *ngIf="!action" (click)="onAction()"><mat-icon>close</mat-icon></button>
